import React, { useContext, useEffect, useRef, useState } from "react";
import { Card, CardDeck, Container, Table } from "react-bootstrap";
import {
  data,
  channel,
  pricingFaq,
  silver,
  gold,
  platinum,
  silver1,
} from "../../asset/json/pricing";
import { money } from "../../asset/json/money";
import "react-toastify/dist/ReactToastify.css";
import check from "../../asset/image/check-o.svg";
import close from "../../asset/image/close-o.svg";
import "../../styles/pricing.scss";
import {
  SilverButton,
  SilverPayButton,
  GoldPayButton,
  GoldButton,
  PlatinumButton,
  PlatinumPayButton,
} from "../common/Buttons";
import "../common/tooltip.css";
import { socialIcon } from "../../asset/json/CardDetail";
import firebase from "../../firebase";
import { Helmet } from "react-helmet";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
} from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { makeStyles } from "@material-ui/core/styles";
import { userContent } from "../../index";
import { blue } from "@material-ui/core/colors";
import { Fade, Zoom, Slide, Bounce } from "react-reveal";
import axios from "axios";
import { Link, Redirect } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100px",
    fontFamily: "Montserrat",
  },
  heading: {
    fontSize: theme.typography.pxToRem(15),
    color: "white",
  },
  title: {
    fontSize: theme.typography.pxToRem(25),
    fontWeight: "bold",
  },
  secondaryHeading: {
    fontSize: theme.typography.pxToRem(15),
    color: "#fff !important",
    paddingLeft: "3%",
  },
  secondaryContent: {
    fontSize: theme.typography.pxToRem(15),
    color: "#859db6",
    padding: "0 5%",
  },
  popover: {
    pointerEvents: "none",
    fontFamily: "Montserrat",
  },
  paper: {
    padding: theme.spacing(1),
    backgroundColor: "#39393E",
    borderRadius: "10px",
    color: "#FFFFFF",
    width: "200px",
    fontFamily: "Montserrat",
  },
}));

const Pricing = () => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [anchorid, setAnchorid] = React.useState(null);
  const [data11, setData11] = React.useState("");
  const button1 = useRef();
  const handlePopoverOpen = (event, id) => {
    setAnchorEl(event.currentTarget);
    setAnchorid(id);
  };

  const handlePopoverClose = () => {
    setAnchorEl(null);
    setAnchorid(null);
  };

  const open = Boolean(anchorEl);
  const posts = useContext(userContent);
  console.log(posts[0], "posts");

  // const reloader = async () => {
  //   await axios.get("https://api.ipify.org/?format=json").then((data) => {
  //     let url = `https://ipapi.co/${data.data.ip}/json/`;
  //     axios.get(url).then((re) => {
  //       setData11(re.data.currency);
  //     });
  //   });
  // };
  const reloader = async () => {
    await axios.get("https://api.db-ip.com/v2/free/self").then((data) => {
      let url = `https://ipapi.co/${data.data.ipAddress}/json/`;
      axios.get(url).then((re) => {
        setData11(re.data.currency);
      });
    });
  };

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
    });
    reloader();
  }, []);

  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const [show, setShow] = useState(false);
  const handelChange = () => {
    setShow(!show);
  };

  // const value1 = money.filter((money) => money.Currency === posts[0]);
  // const value2 = money.filter((money) => money.Currency === data11);
  const value1 = money.filter((money) => money.CountryCode === posts[0]);
  const value2 = money.filter((money) => money.CountryCode === data11);

  // console.log(value2);
  if (posts.length > 0) {
    return (
      <div>
        <Helmet>
          <meta charSet="utf-8" name="CloudSocial Pricing page" />
          <meta
            name="description"
            content="CloudSocial provides social media post scheduling tools for small businesses, brands, digital agencies. Check out how much does CloudSocial cost? Try it free."
          />
          <title>
            Social Media Post Scheduler - Pricing and Packages | CloudSocial
          </title>
          <link rel="canonical" href="https://cloudsocial.io/pricing" />
        </Helmet>
        <div></div>

        <Container fluid>
          <div className="pricingContent">
            <h1 className="pricingTitle">
              Social Media Management Tool Pricing
            </h1>
            <div class="btn-container">
              <label class="switch btn-color-mode-switch">
                <input
                  type="checkbox"
                  name="color_mode"
                  id="color_mode"
                  value="1"
                  ref={button1}
                  onChange={handelChange}
                />
                <label
                  htmlFor="color_mode"
                  data-on="Yearly"
                  data-off="Monthly"
                  class="btn-color-mode-switch-inner"
                ></label>
              </label>
            </div>
          </div>
          <div className="pricing-align">
            <div class="grid-container">
              <div class="nodata"></div>
              {/* <div class="card11">
                <Card className="normalCard">
                  <h5>&nbsp;</h5>
                  <Card.Body className="packageData">
                    <Card.Title className="pricingCardTitle">Silver</Card.Title>
                    <Card.Subtitle
                      className={`${show ? "showPrice" : "month"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Subtitle
                      className={`${show ? "month" : "showPrice"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Text className="packageData">
                      <div
                        className={`${show ? "pricingProduct" : "showPrice"}`}
                      >
                        {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                        {value1.length > 0
                          ? value1[0].Pack_Prices_Billed_Annually.Silver
                          : "13"}
                      </div>

                      <div
                        className={`${show ? "showPrice" : "pricingProduct"}`}
                      >
                        {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                        {value1.length > 0
                          ? value1[0].Pack_Prices_Monthly.Silver
                          : "17"}
                      </div>
                      <div
                        className={`${show ? "pricingBillData" : "showPrice"}`}
                      >
                        Billed Annually
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingBillData"}`}
                      >
                        &nbsp;
                      </div>
                      <div className="pricingTrailButton">
                        <Bounce>
                          <SilverPayButton />
                        </Bounce>
                      </div>

                      <div className="creditCardData">
                        <hr className="creditHr" />
                        <div className="credit-card">
                          No Credit Card Required
                        </div>
                        Best suited for entrepreneurs, small businesses and
                        freelancers
                      </div>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer></Card.Footer>
                </Card>
              </div> */}
              <div class="card2">
                <Card className="mainCard" style={{ border: "none" }}>
                  <h5>Most Popular</h5>
                  <Card.Body className="packageData">
                    <Card.Title className="pricingCardTitle">Gold</Card.Title>
                    <Card.Subtitle
                      className={`${show ? "showPrice" : "month"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Subtitle
                      className={`${show ? "month" : "showPrice"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Text className="packageData">
                      <div
                        className={`${show ? "pricingProduct" : "showPrice"}`}
                      >
                        {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                        {value1.length > 0
                          ? value1[0].Pack_Prices_Billed_Annually.Gold
                          : "70"}
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingProduct"}`}
                      >
                        {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                        {value1.length > 0
                          ? value1[0].Pack_Prices_Monthly.Gold
                          : "100"}
                      </div>

                      <div
                        className={`${show ? "pricingBillData" : "showPrice"}`}
                      >
                        Billed Annually
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingBillData"}`}
                      >
                        &nbsp;
                      </div>
                      <div className="pricingTrailButton">
                        <Bounce>
                          <GoldPayButton />
                        </Bounce>
                      </div>

                      <div className="creditCardData">
                        <hr className="creditHr" />
                        <div className="credit-card">
                          No Credit Card Required
                        </div>
                        Best suited for brands
                      </div>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>{/* <GoldButton /> */}</Card.Footer>
                </Card>
              </div>
              <div class="card3">
                <Card className="normalCard">
                  <h5>&nbsp;</h5>
                  <Card.Body className="packageData">
                    <Card.Title className="pricingCardTitle">
                      Platinum
                    </Card.Title>
                    <Card.Subtitle
                      className={`${show ? "showPrice" : "month"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Subtitle
                      className={`${show ? "month" : "showPrice"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Text className="packageData">
                      <div
                        className={`${show ? "pricingProduct" : "showPrice"}`}
                      >
                        {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                        {value1.length > 0
                          ? value1[0].Pack_Prices_Billed_Annually.Platinum
                          : "225"}
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingProduct"}`}
                      >
                        {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                        {value1.length > 0
                          ? value1[0].Pack_Prices_Monthly.Platinum
                          : "354"}
                      </div>

                      <div
                        className={`${show ? "pricingBillData" : "showPrice"}`}
                      >
                        Billed Annually
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingBillData"}`}
                      >
                        &nbsp;
                      </div>
                      <div className="pricingTrailButton">
                        <Bounce>
                          <PlatinumPayButton />
                        </Bounce>
                      </div>
                      <div className="creditCardData">
                        <hr className="creditHr" />
                        <div className="credit-card">
                          No Credit Card Required
                        </div>
                        Best suited for social media and digital agencies
                      </div>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>{/* <PlatinumButton /> */}</Card.Footer>
                </Card>
              </div>
              <div class="tabledata">
                <div className="layer1">
                  <Table>
                    <tbody>
                      <tr style={{ backgroundColor: data.color }}>
                        <td style={{ textAlign: "left", fontWeight: "600" }}>
                          Supported Social Channels
                        </td>
                        {/* <td>
                          <div className="icon-div icon-div2">
                            {socialIcon.map(({ img, title, id, content }) => (
                              <div>
                                <img
                                  aria-owns={open ? 2 : undefined}
                                  aria-haspopup="true"
                                  onMouseEnter={(event) => {
                                    setAnchorEl(event.currentTarget);
                                    setAnchorid(id);
                                  }}
                                  onMouseLeave={() => {
                                    setAnchorEl(null);
                                    setAnchorid(null);
                                  }}
                                  loading="lazy"
                                  alt={title}
                                  className="icon-social"
                                  letiant="top"
                                  src={img}
                                />
                                <Popover
                                  id="2"
                                  className={classes.popover}
                                  classes={{
                                    paper: classes.paper,
                                  }}
                                  open={anchorid == id}
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                  }}
                                  onClose={handlePopoverClose}
                                  disableRestoreFocus
                                >
                                  <Typography>{content}</Typography>
                                </Popover>
                              </div>
                            ))}
                          </div>
                        </td> */}
                        <td>
                          <div className="icon-div icon-div2">
                            {socialIcon.map(({ img, title, id, content }) => (
                              <div>
                                <img
                                  aria-owns={open ? 2 : undefined}
                                  aria-haspopup="true"
                                  onMouseEnter={(event) => {
                                    setAnchorEl(event.currentTarget);
                                    setAnchorid(id);
                                  }}
                                  onMouseLeave={() => {
                                    setAnchorEl(null);
                                    setAnchorid(null);
                                  }}
                                  loading="lazy"
                                  alt={title}
                                  className="icon-social"
                                  letiant="top"
                                  src={img}
                                />
                                <Popover
                                  id="2"
                                  className={classes.popover}
                                  classes={{
                                    paper: classes.paper,
                                  }}
                                  open={anchorid == id}
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                  }}
                                  onClose={handlePopoverClose}
                                  disableRestoreFocus
                                >
                                  <Typography>{content}</Typography>
                                </Popover>
                              </div>
                            ))}
                          </div>
                        </td>
                        <td>
                          <div className="icon-div icon-div2">
                            {socialIcon.map(({ img, title, id, content }) => (
                              <div>
                                <img
                                  aria-owns={open ? 2 : undefined}
                                  aria-haspopup="true"
                                  onMouseEnter={(event) => {
                                    setAnchorEl(event.currentTarget);
                                    setAnchorid(id);
                                  }}
                                  onMouseLeave={() => {
                                    setAnchorEl(null);
                                    setAnchorid(null);
                                  }}
                                  loading="lazy"
                                  alt={title}
                                  className="icon-social"
                                  letiant="top"
                                  src={img}
                                />
                                <Popover
                                  id="2"
                                  className={classes.popover}
                                  classes={{
                                    paper: classes.paper,
                                  }}
                                  open={anchorid == id}
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                  }}
                                  onClose={handlePopoverClose}
                                  disableRestoreFocus
                                >
                                  <Typography>{content}</Typography>
                                </Popover>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                      {channel.map((data, index) => {
                        return (
                          <tr
                            key={index}
                            style={{ backgroundColor: data.color }}
                          >
                            <td style={{ textAlign: "left" }}>{data.title}</td>
                            {/* <td>{data.silver}</td> */}
                            <td>{data.gold}</td>
                            <td>{data.platinum}</td>
                          </tr>
                        );
                      })}
                      {data.map((data, index) => {
                        return (
                          <tr
                            key={index}
                            style={{
                              backgroundColor: data.color,
                              fontWeight: data.font,
                            }}
                          >
                            <td
                              style={{
                                textAlign: "left",
                                fontWeight: data.bold,
                              }}
                            >
                              {data.title}
                            </td>
                            {/* <td>
                              {data.silver === "open" ? (
                                <img
                                  alt="checkImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={check}
                                />
                              ) : data.silver === "close" ? (
                                <img
                                  alt="closeImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={close}
                                />
                              ) : (
                                ""
                              )}
                            </td> */}
                            <td>
                              {data.gold === "open" ? (
                                <img
                                  alt="checkImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={check}
                                />
                              ) : data.gold === "close" ? (
                                <img
                                  alt="closeImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={close}
                                />
                              ) : (
                                " "
                              )}
                            </td>
                            <td>
                              {data.platinum === "open" ? (
                                <img
                                  alt="checkImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={check}
                                />
                              ) : data.platinum === "close" ? (
                                <img
                                  alt="closeImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={close}
                                />
                              ) : (
                                " "
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td></td>
                        {/* <td>
                          <Bounce>
                            <SilverButton />
                          </Bounce>
                        </td> */}
                        <td>
                          <Bounce>
                            <GoldButton />
                          </Bounce>
                        </td>
                        <td>
                          <Bounce>
                            <PlatinumButton />
                          </Bounce>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </Container>

        <div>
          <CardDeck className="smallPannel">
            {/* <Card className="normalCard">
              <Card.Body className="smallCard">
                <Card.Text className="packageData">
                  <Card.Title className="pricingCardTitle mt-3">
                    Silver
                  </Card.Title>
                  <Card.Subtitle className={`${show ? "showPrice" : "month"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Subtitle className={`${show ? "month" : "showPrice"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Body className="packageData">
                    <div className={`${show ? "pricingProduct" : "showPrice"}`}>
                      {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                      {value1.length > 0
                        ? value1[0].Pack_Prices_Billed_Annually.Silver
                        : "13"}
                    </div>
                    <div className={`${show ? "showPrice" : "pricingProduct"}`}>
                      {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                      {value1.length > 0
                        ? value1[0].Pack_Prices_Monthly.Silver
                        : "13"}
                    </div>
                    <div
                      className={`${show ? "pricingBillData" : "showPrice"}`}
                    >
                      Billed Annually
                    </div>
                    <div
                      className={`${show ? "showPrice" : "pricingBillData"}`}
                    >
                      &nbsp;
                    </div>
                    <div className="pricingTrailButton">
                      <Bounce>
                        <SilverPayButton />
                      </Bounce>
                    </div>

                    <div className="creditCardData">
                      <hr />
                      <div>No Credit Card Required</div>
                      Best suited for entrepreneurs, small businesses and
                      freelancers
                    </div>
                    <div className="icon-div icon-div2">
                      {socialIcon.map(({ img, title, id, content }) => (
                        <div>
                          <img
                            aria-owns={open ? 2 : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => {
                              setAnchorEl(event.currentTarget);
                              setAnchorid(id);
                            }}
                            onMouseLeave={() => {
                              setAnchorEl(null);
                              setAnchorid(null);
                            }}
                            loading="lazy"
                            alt={title}
                            className="icon-social"
                            letiant="top"
                            src={img}
                          />
                          <Popover
                            id="2"
                            className={classes.popover}
                            classes={{
                              paper: classes.paper,
                            }}
                            open={anchorid == id}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                          >
                            <Typography>{content}</Typography>
                          </Popover>
                        </div>
                      ))}
                    </div>
                    <Card.Body className="smallCard">
                      <ul>
                        {silver.map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                        {silver1.map((data, index) => {
                          return (
                            <li
                              style={{ textDecoration: "line-through" }}
                              key={index}
                            >
                              {data}
                            </li>
                          );
                        })}
                      </ul>
                    </Card.Body>
                  </Card.Body>
                </Card.Text>
              </Card.Body>
              <Card.Footer>
                <Bounce>
                  <SilverButton />
                </Bounce>
              </Card.Footer>
            </Card> */}
            <Card className="mainCard">
              <h5>Most Popular</h5>
              <Card.Body className="smallCard">
                {/* <Card.Title>Gold</Card.Title> */}
                <Card.Text className="packageData">
                  <Card.Title className="pricingCardTitle mt-3">
                    Gold
                  </Card.Title>
                  <Card.Subtitle className={`${show ? "showPrice" : "month"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Subtitle className={`${show ? "month" : "showPrice"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Text className="packageData">
                    <div className={`${show ? "pricingProduct" : "showPrice"}`}>
                      {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                      {value1.length > 0
                        ? value1[0].Pack_Prices_Billed_Annually.Gold
                        : "70"}
                    </div>
                    <div className={`${show ? "showPrice" : "pricingProduct"}`}>
                      {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                      {value1.length > 0
                        ? value1[0].Pack_Prices_Monthly.Gold
                        : "100"}
                    </div>

                    <div
                      className={`${show ? "pricingBillData" : "showPrice"}`}
                    >
                      Billed Annually
                    </div>
                    <div
                      className={`${show ? "showPrice" : "pricingBillData"}`}
                    >
                      &nbsp;
                    </div>
                    <div className="pricingTrailButton">
                      <Bounce>
                        <GoldPayButton />
                      </Bounce>
                    </div>

                    <div className="creditCardData">
                      <hr />
                      <div>No Credit Card Required</div>
                      Best suited for entrepreneurs, small businesses and
                      freelancers
                    </div>
                    <div className="icon-div icon-div2">
                      {socialIcon.map(({ img, title, id, content }) => (
                        <div>
                          <img
                            aria-owns={open ? 2 : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => {
                              setAnchorEl(event.currentTarget);
                              setAnchorid(id);
                            }}
                            onMouseLeave={() => {
                              setAnchorEl(null);
                              setAnchorid(null);
                            }}
                            loading="lazy"
                            alt={title}
                            className="icon-social"
                            letiant="top"
                            src={img}
                          />
                          <Popover
                            id="2"
                            className={classes.popover}
                            classes={{
                              paper: classes.paper,
                            }}
                            open={anchorid == id}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                          >
                            <Typography>{content}</Typography>
                          </Popover>
                        </div>
                      ))}
                    </div>
                    <Card.Body className="smallCard">
                      <ul>
                        {gold.map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                      </ul>
                    </Card.Body>
                  </Card.Text>
                </Card.Text>
              </Card.Body>

              <Card.Footer>
                <Bounce>
                  <GoldButton />
                </Bounce>
              </Card.Footer>
            </Card>
            <Card className="normalCard">
              <Card.Body className="smallCard">
                <Card.Text className="packageData">
                  <Card.Title className="pricingCardTitle mt-3">
                    Platinum
                  </Card.Title>
                  <Card.Subtitle className={`${show ? "showPrice" : "month"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Subtitle className={`${show ? "month" : "showPrice"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Text className="packageData">
                    <div className={`${show ? "pricingProduct" : "showPrice"}`}>
                      {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                      {value1.length > 0
                        ? value1[0].Pack_Prices_Billed_Annually.Platinum
                        : "225"}
                    </div>
                    <div className={`${show ? "showPrice" : "pricingProduct"}`}>
                      {value1.length > 0 ? value1[0].CurrencyCode : "$"}
                      {value1.length > 0
                        ? value1[0].Pack_Prices_Monthly.Platinum
                        : "345"}
                    </div>

                    <div
                      className={`${show ? "pricingBillData" : "showPrice"}`}
                    >
                      Billed Annually
                    </div>
                    <div
                      className={`${show ? "showPrice" : "pricingBillData"}`}
                    >
                      &nbsp;
                    </div>
                    <div className="pricingTrailButton">
                      <Bounce>
                        <PlatinumPayButton />
                      </Bounce>
                    </div>
                    <div className="creditCardData">
                      <hr />
                      <div>No Credit Card Required</div>
                      Best suited for entrepreneurs, small businesses and
                      freelancers
                    </div>
                    <div className="icon-div icon-div2">
                      {socialIcon.map(({ img, title, id, content }) => (
                        <div>
                          <img
                            aria-owns={open ? 2 : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => {
                              setAnchorEl(event.currentTarget);
                              setAnchorid(id);
                            }}
                            onMouseLeave={() => {
                              setAnchorEl(null);
                              setAnchorid(null);
                            }}
                            loading="lazy"
                            alt={title}
                            className="icon-social"
                            letiant="top"
                            src={img}
                          />
                          <Popover
                            id="2"
                            className={classes.popover}
                            classes={{
                              paper: classes.paper,
                            }}
                            open={anchorid == id}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                          >
                            <Typography>{content}</Typography>
                          </Popover>
                        </div>
                      ))}
                    </div>
                    <Card.Body className="smallCard">
                      <ul>
                        {platinum.map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                      </ul>
                    </Card.Body>
                  </Card.Text>
                </Card.Text>
              </Card.Body>
              <Card.Footer className="footerLogin">
                <Bounce>
                  <PlatinumButton />
                </Bounce>
              </Card.Footer>
            </Card>
          </CardDeck>
          <h5 className="offer">
            *During trial period 250 and 500 mentions (listen) will be allocated
            to Gold & Platinum pack respectively.
          </h5>
          {/* <div
            className="mb-2"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <div
              className="pl-2 pr-2"
              style={{ borderRight: "2px solid #859db6", fontWeight: "600" }}
            >
              Try our Limited Silver Plan
            </div>
            <div
              className="pl-2  pr-2"
              style={{ borderRight: "2px solid #859db6" }}
            >
              12 Social Channels
            </div>
            <div
              className="pl-2 pr-2"
              style={{ borderRight: "2px solid #859db6" }}
            >
              3 Users
            </div>
            <div className="pl-2 pr-2">
              <Link className="" to="/detail-pricing">
                Show More
              </Link>
            </div>
          </div> */}
          <div className="faqPricing">
            <h2 className="faqTitle">FAQ</h2>
            <div className="FaqDetail">
              Curated FAQ’S are listed here. Try the help widget for
              comprehensive
              <br /> list of FAQ’S in the Knowledge Bank
            </div>
            <div>
              {pricingFaq.map((data, index) => {
                return (
                  <Accordion
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                    className="pricingFaqAccordion"
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <Typography
                        className={classes.heading}
                        style={{
                          backgroundColor: "#6D6EF3",
                          borderRadius: "50%",
                          height: "fit-content",
                          textAlign: "center",
                        }}
                      >
                        <div className="faqDropform">?</div>
                      </Typography>
                      <Typography className={classes.secondaryHeading}>
                        {data.title}
                      </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.secondaryContent}>
                        {data.content}
                        <ul>
                          {data.table.map((re) => {
                            return <li>{re}</li>;
                          })}
                        </ul>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div>
        <Helmet>
          <meta name="description" content="CLoudSocial Pricing page" />
          <title>Pricing</title>
          <link rel="canonical" href="https://cloudsocial.io/pricing" />
        </Helmet>
        <div></div>

        <Container fluid>
          <div className="pricingContent">
            <h1 className="pricingTitle">
              Social Media Management Tool Pricing
            </h1>
            <div class="btn-container">
              <label class="switch btn-color-mode-switch">
                <input
                  type="checkbox"
                  name="color_mode"
                  id="color_mode"
                  value="1"
                  ref={button1}
                  onChange={handelChange}
                />
                <label
                  htmlFor="color_mode"
                  data-on="Yearly"
                  data-off="Monthly"
                  class="btn-color-mode-switch-inner"
                ></label>
              </label>
            </div>
          </div>
          <div className="pricing-align">
            <div class="grid-container">
              <div class="nodata"></div>
              {/* <div class="card11">
                <Card className="normalCard">
                  <h5>&nbsp;</h5>
                  <Card.Body className="packageData">
                    <Card.Title className="pricingCardTitle">Silver</Card.Title>
                    <Card.Subtitle
                      className={`${show ? "showPrice" : "month"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Subtitle
                      className={`${show ? "month" : "showPrice"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Text className="packageData">
                      <div
                        className={`${show ? "pricingProduct" : "showPrice"}`}
                      >
                        {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                        {value2.length > 0
                          ? value2[0].Pack_Prices_Billed_Annually.Silver
                          : "13"}
                      </div>

                      <div
                        className={`${show ? "showPrice" : "pricingProduct"}`}
                      >
                        {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                        {value2.length > 0
                          ? value2[0].Pack_Prices_Monthly.Silver
                          : "17"}
                      </div>
                      <div
                        className={`${show ? "pricingBillData" : "showPrice"}`}
                      >
                        Billed Annually
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingBillData"}`}
                      >
                        &nbsp;
                      </div>
                      <div className="pricingTrailButton">
                        <Bounce>
                          <SilverPayButton />
                        </Bounce>
                      </div>

                      <div className="creditCardData">
                        <hr className="creditHr" />
                        <div className="credit-card">
                          No Credit Card Required
                        </div>
                        Best suited for entrepreneurs, small businesses and
                        freelancers
                      </div>
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div> */}
              <div class="card2">
                <Card className="mainCard" style={{ border: "none" }}>
                  <h5>Most Popular</h5>
                  <Card.Body className="packageData">
                    <Card.Title className="pricingCardTitle">Gold</Card.Title>
                    <Card.Subtitle
                      className={`${show ? "showPrice" : "month"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Subtitle
                      className={`${show ? "month" : "showPrice"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Text className="packageData">
                      <div
                        className={`${show ? "pricingProduct" : "showPrice"}`}
                      >
                        {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                        {value2.length > 0
                          ? value2[0].Pack_Prices_Billed_Annually.Gold
                          : "70"}
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingProduct"}`}
                      >
                        {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                        {value2.length > 0
                          ? value2[0].Pack_Prices_Monthly.Gold
                          : "100"}
                      </div>

                      <div
                        className={`${show ? "pricingBillData" : "showPrice"}`}
                      >
                        Billed Annually
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingBillData"}`}
                      >
                        &nbsp;
                      </div>
                      <div className="pricingTrailButton">
                        <Bounce>
                          <GoldPayButton />
                        </Bounce>
                      </div>

                      <div className="creditCardData">
                        <hr className="creditHr" />
                        <div className="credit-card">
                          No Credit Card Required
                        </div>
                        Best suited for brands
                      </div>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>{/* <GoldButton /> */}</Card.Footer>
                </Card>
              </div>
              <div class="card3">
                <Card className="normalCard">
                  <h5>&nbsp;</h5>
                  <Card.Body className="packageData">
                    <Card.Title className="pricingCardTitle">
                      Platinum
                    </Card.Title>
                    <Card.Subtitle
                      className={`${show ? "showPrice" : "month"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Subtitle
                      className={`${show ? "month" : "showPrice"}`}
                    >
                      Per Month
                    </Card.Subtitle>
                    <Card.Text className="packageData">
                      <div
                        className={`${show ? "pricingProduct" : "showPrice"}`}
                      >
                        {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                        {value2.length > 0
                          ? value2[0].Pack_Prices_Billed_Annually.Platinum
                          : "225"}
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingProduct"}`}
                      >
                        {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                        {value2.length > 0
                          ? value2[0].Pack_Prices_Monthly.Platinum
                          : "354"}
                      </div>

                      <div
                        className={`${show ? "pricingBillData" : "showPrice"}`}
                      >
                        Billed Annually
                      </div>
                      <div
                        className={`${show ? "showPrice" : "pricingBillData"}`}
                      >
                        &nbsp;
                      </div>
                      <div className="pricingTrailButton">
                        <Bounce>
                          <PlatinumPayButton />
                        </Bounce>
                      </div>
                      <div className="creditCardData">
                        <hr className="creditHr" />
                        <div className="credit-card">
                          No Credit Card Required
                        </div>
                        Best suited for social media and digital agencies
                      </div>
                    </Card.Text>
                  </Card.Body>
                  <Card.Footer>{/* <PlatinumButton /> */}</Card.Footer>
                </Card>
              </div>
              <div class="tabledata">
                <div className="layer1">
                  <Table>
                    <tbody>
                      <tr style={{ backgroundColor: data.color }}>
                        <td style={{ textAlign: "left", fontWeight: "600" }}>
                          Supported Social Channels
                        </td>
                        <td>
                          <div className="icon-div icon-div2">
                            {socialIcon.map(({ img, title, id, content }) => (
                              <div>
                                <img
                                  aria-owns={open ? 2 : undefined}
                                  aria-haspopup="true"
                                  onMouseEnter={(event) => {
                                    setAnchorEl(event.currentTarget);
                                    setAnchorid(id);
                                  }}
                                  onMouseLeave={() => {
                                    setAnchorEl(null);
                                    setAnchorid(null);
                                  }}
                                  loading="lazy"
                                  alt={title}
                                  className="icon-social"
                                  letiant="top"
                                  src={img}
                                />
                                <Popover
                                  id="2"
                                  className={classes.popover}
                                  classes={{
                                    paper: classes.paper,
                                  }}
                                  open={anchorid == id}
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                  }}
                                  onClose={handlePopoverClose}
                                  disableRestoreFocus
                                >
                                  <Typography>{content}</Typography>
                                </Popover>
                              </div>
                            ))}
                          </div>
                        </td>
                        {/* <td>
                          <div className="icon-div icon-div2">
                            {socialIcon.map(({ img, title, id, content }) => (
                              <div>
                                <img
                                  aria-owns={open ? 2 : undefined}
                                  aria-haspopup="true"
                                  onMouseEnter={(event) => {
                                    setAnchorEl(event.currentTarget);
                                    setAnchorid(id);
                                  }}
                                  onMouseLeave={() => {
                                    setAnchorEl(null);
                                    setAnchorid(null);
                                  }}
                                  loading="lazy"
                                  alt={title}
                                  className="icon-social"
                                  letiant="top"
                                  src={img}
                                />
                                <Popover
                                  id="2"
                                  className={classes.popover}
                                  classes={{
                                    paper: classes.paper,
                                  }}
                                  open={anchorid == id}
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                  }}
                                  onClose={handlePopoverClose}
                                  disableRestoreFocus
                                >
                                  <Typography>{content}</Typography>
                                </Popover>
                              </div>
                            ))}
                          </div>
                        </td> */}
                        <td>
                          <div className="icon-div icon-div2">
                            {socialIcon.map(({ img, title, id, content }) => (
                              <div>
                                <img
                                  aria-owns={open ? 2 : undefined}
                                  aria-haspopup="true"
                                  onMouseEnter={(event) => {
                                    setAnchorEl(event.currentTarget);
                                    setAnchorid(id);
                                  }}
                                  onMouseLeave={() => {
                                    setAnchorEl(null);
                                    setAnchorid(null);
                                  }}
                                  loading="lazy"
                                  alt={title}
                                  className="icon-social"
                                  letiant="top"
                                  src={img}
                                />
                                <Popover
                                  id="2"
                                  className={classes.popover}
                                  classes={{
                                    paper: classes.paper,
                                  }}
                                  open={anchorid == id}
                                  anchorEl={anchorEl}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "left",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "left",
                                  }}
                                  onClose={handlePopoverClose}
                                  disableRestoreFocus
                                >
                                  <Typography>{content}</Typography>
                                </Popover>
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                      {channel.map((data, index) => {
                        return (
                          <tr
                            key={index}
                            style={{ backgroundColor: data.color }}
                          >
                            <td style={{ textAlign: "left" }}>{data.title}</td>
                            {/* <td>{data.silver}</td> */}
                            <td>{data.gold}</td>
                            <td>{data.platinum}</td>
                          </tr>
                        );
                      })}
                      {data.map((data, index) => {
                        return (
                          <tr
                            key={index}
                            style={{
                              backgroundColor: data.color,
                              fontWeight: data.font,
                            }}
                          >
                            <td
                              style={{
                                textAlign: "left",
                                fontWeight: data.bold,
                              }}
                            >
                              {data.title}
                            </td>
                            {/* <td>
                              {data.silver === "open" ? (
                                <img
                                  alt="checkImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={check}
                                />
                              ) : data.silver === "close" ? (
                                <img
                                  alt="closeImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={close}
                                />
                              ) : (
                                ""
                              )}
                            </td> */}
                            <td>
                              {data.gold === "open" ? (
                                <img
                                  alt="checkImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={check}
                                />
                              ) : data.gold === "close" ? (
                                <img
                                  alt="closeImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={close}
                                />
                              ) : (
                                " "
                              )}
                            </td>
                            <td>
                              {data.platinum === "open" ? (
                                <img
                                  alt="checkImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={check}
                                />
                              ) : data.platinum === "close" ? (
                                <img
                                  alt="closeImage"
                                  loading="lazy"
                                  width="22px"
                                  height="22px"
                                  src={close}
                                />
                              ) : (
                                " "
                              )}
                            </td>
                          </tr>
                        );
                      })}
                      <tr>
                        <td></td>
                        {/* <td>
                          <Bounce>
                            <SilverButton />
                          </Bounce>
                        </td> */}
                        <td>
                          <Bounce>
                            <GoldButton />
                          </Bounce>
                        </td>
                        <td>
                          <Bounce>
                            <PlatinumButton />
                          </Bounce>
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </div>
              </div>
            </div>
          </div>
        </Container>

        <div>
          <CardDeck className="smallPannel">
            {/* <Card className="normalCard">
              <Card.Body className="smallCard">
                <Card.Text className="packageData">
                  <Card.Title className="pricingCardTitle mt-3">
                    Silver
                  </Card.Title>
                  <Card.Subtitle className={`${show ? "showPrice" : "month"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Subtitle className={`${show ? "month" : "showPrice"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Body className="packageData">
                    <div className={`${show ? "pricingProduct" : "showPrice"}`}>
                      {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                      {value2.length > 0
                        ? value2[0].Pack_Prices_Billed_Annually.Silver
                        : "13"}
                    </div>
                    <div className={`${show ? "showPrice" : "pricingProduct"}`}>
                      {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                      {value2.length > 0
                        ? value2[0].Pack_Prices_Monthly.Silver
                        : "13"}
                    </div>
                    <div
                      className={`${show ? "pricingBillData" : "showPrice"}`}
                    >
                      Billed Annually
                    </div>
                    <div
                      className={`${show ? "showPrice" : "pricingBillData"}`}
                    >
                      &nbsp;
                    </div>
                    <div className="pricingTrailButton">
                      <Bounce>
                        <SilverPayButton />
                      </Bounce>
                    </div>

                    <div className="creditCardData">
                      <hr />
                      <div>No Credit Card Required</div>
                      Best suited for entrepreneurs, small businesses and
                      freelancers
                    </div>
                    <div className="icon-div icon-div2">
                      {socialIcon.map(({ img, title, id, content }) => (
                        <div>
                          <img
                            aria-owns={open ? 2 : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => {
                              setAnchorEl(event.currentTarget);
                              setAnchorid(id);
                            }}
                            onMouseLeave={() => {
                              setAnchorEl(null);
                              setAnchorid(null);
                            }}
                            loading="lazy"
                            alt={title}
                            className="icon-social"
                            letiant="top"
                            src={img}
                          />
                          <Popover
                            id="2"
                            className={classes.popover}
                            classes={{
                              paper: classes.paper,
                            }}
                            open={anchorid == id}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                          >
                            <Typography>{content}</Typography>
                          </Popover>
                        </div>
                      ))}
                    </div>
                    <Card.Body className="smallCard">
                      <ul>
                        {silver.map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                        {silver1.map((data, index) => {
                          return (
                            <li
                              style={{ textDecoration: "line-through" }}
                              key={index}
                            >
                              {data}
                            </li>
                          );
                        })}
                      </ul>
                    </Card.Body>
                  </Card.Body>
                </Card.Text>
              </Card.Body>
              <Card.Footer>
                <Bounce>
                  <SilverButton />
                </Bounce>
              </Card.Footer>
            </Card> */}
            <Card className="mainCard">
              <h5>Most Popular</h5>
              <Card.Body className="smallCard">
                {/* <Card.Title>Gold</Card.Title> */}
                <Card.Text className="packageData">
                  <Card.Title className="pricingCardTitle mt-3">
                    Gold
                  </Card.Title>
                  <Card.Subtitle className={`${show ? "showPrice" : "month"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Subtitle className={`${show ? "month" : "showPrice"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Text className="packageData">
                    <div className={`${show ? "pricingProduct" : "showPrice"}`}>
                      {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                      {value2.length > 0
                        ? value2[0].Pack_Prices_Billed_Annually.Gold
                        : "70"}
                    </div>
                    <div className={`${show ? "showPrice" : "pricingProduct"}`}>
                      {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                      {value2.length > 0
                        ? value2[0].Pack_Prices_Monthly.Gold
                        : "100"}
                    </div>

                    <div
                      className={`${show ? "pricingBillData" : "showPrice"}`}
                    >
                      Billed Annually
                    </div>
                    <div
                      className={`${show ? "showPrice" : "pricingBillData"}`}
                    >
                      &nbsp;
                    </div>
                    <div className="pricingTrailButton">
                      <Bounce>
                        <GoldPayButton />
                      </Bounce>
                    </div>

                    <div className="creditCardData">
                      <hr />
                      <div>No Credit Card Required</div>
                      Best suited for entrepreneurs, small businesses and
                      freelancers
                    </div>
                    <div className="icon-div icon-div2">
                      {socialIcon.map(({ img, title, id, content }) => (
                        <div>
                          <img
                            aria-owns={open ? 2 : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => {
                              setAnchorEl(event.currentTarget);
                              setAnchorid(id);
                            }}
                            onMouseLeave={() => {
                              setAnchorEl(null);
                              setAnchorid(null);
                            }}
                            loading="lazy"
                            alt={title}
                            className="icon-social"
                            letiant="top"
                            src={img}
                          />
                          <Popover
                            id="2"
                            className={classes.popover}
                            classes={{
                              paper: classes.paper,
                            }}
                            open={anchorid == id}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                          >
                            <Typography>{content}</Typography>
                          </Popover>
                        </div>
                      ))}
                    </div>
                    <Card.Body className="smallCard">
                      <ul>
                        {gold.map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                      </ul>
                    </Card.Body>
                  </Card.Text>
                </Card.Text>
              </Card.Body>

              <Card.Footer>
                <Bounce>
                  <GoldButton />
                </Bounce>
              </Card.Footer>
            </Card>
            <Card className="normalCard">
              <Card.Body className="smallCard">
                <Card.Text className="packageData">
                  <Card.Title className="pricingCardTitle mt-3">
                    Platinum
                  </Card.Title>
                  <Card.Subtitle className={`${show ? "showPrice" : "month"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Subtitle className={`${show ? "month" : "showPrice"}`}>
                    Per Month
                  </Card.Subtitle>
                  <Card.Text className="packageData">
                    <div className={`${show ? "pricingProduct" : "showPrice"}`}>
                      {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                      {value2.length > 0
                        ? value2[0].Pack_Prices_Billed_Annually.Platinum
                        : "225"}
                    </div>
                    <div className={`${show ? "showPrice" : "pricingProduct"}`}>
                      {value2.length > 0 ? value2[0].CurrencyCode : "$"}
                      {value2.length > 0
                        ? value2[0].Pack_Prices_Monthly.Platinum
                        : "345"}
                    </div>

                    <div
                      className={`${show ? "pricingBillData" : "showPrice"}`}
                    >
                      Billed Annually
                    </div>
                    <div
                      className={`${show ? "showPrice" : "pricingBillData"}`}
                    >
                      &nbsp;
                    </div>
                    <div className="pricingTrailButton">
                      <Bounce>
                        <PlatinumPayButton />
                      </Bounce>
                    </div>
                    <div className="creditCardData">
                      <hr />
                      <div>No Credit Card Required</div>
                      Best suited for entrepreneurs, small businesses and
                      freelancers
                    </div>
                    <div className="icon-div icon-div2">
                      {socialIcon.map(({ img, title, id, content }) => (
                        <div>
                          <img
                            aria-owns={open ? 2 : undefined}
                            aria-haspopup="true"
                            onMouseEnter={(event) => {
                              setAnchorEl(event.currentTarget);
                              setAnchorid(id);
                            }}
                            onMouseLeave={() => {
                              setAnchorEl(null);
                              setAnchorid(null);
                            }}
                            loading="lazy"
                            alt={title}
                            className="icon-social"
                            letiant="top"
                            src={img}
                          />
                          <Popover
                            id="2"
                            className={classes.popover}
                            classes={{
                              paper: classes.paper,
                            }}
                            open={anchorid == id}
                            anchorEl={anchorEl}
                            anchorOrigin={{
                              vertical: "bottom",
                              horizontal: "left",
                            }}
                            transformOrigin={{
                              vertical: "top",
                              horizontal: "left",
                            }}
                            onClose={handlePopoverClose}
                            disableRestoreFocus
                          >
                            <Typography>{content}</Typography>
                          </Popover>
                        </div>
                      ))}
                    </div>
                    <Card.Body className="smallCard">
                      <ul>
                        {platinum.map((data, index) => {
                          return <li key={index}>{data}</li>;
                        })}
                      </ul>
                    </Card.Body>
                  </Card.Text>
                </Card.Text>
              </Card.Body>
              <Card.Footer className="footerLogin">
                <Bounce>
                  <PlatinumButton />
                </Bounce>
              </Card.Footer>
            </Card>
          </CardDeck>
          <h5 className="offer">
            *During trial period 250 and 500 mentions (listen) will be allocated
            to Gold & Platinum pack respectively.
          </h5>
          {/* <div
            className="mb-2"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              flexWrap: "wrap",
            }}
          >
            <div
              className="pl-2 pr-2"
              style={{ borderRight: "2px solid #859db6", fontWeight: "600" }}
            >
              Try our Limited Silver Plan
            </div>
            <div
              className="pl-2  pr-2"
              style={{ borderRight: "2px solid #859db6" }}
            >
              12 Social Channels
            </div>
            <div
              className="pl-2 pr-2"
              style={{ borderRight: "2px solid #859db6" }}
            >
              3 Users
            </div>
            <div className="pl-2 pr-2">
              <Link className="" to="/detail-pricing">
                Show More
              </Link>
            </div>
          </div> */}

          <div className="faqPricing">
            <h2 className="faqTitle">FAQ</h2>
            <div className="FaqDetail">
              Curated FAQ’S are listed here. Try the help widget for
              comprehensive
              <br /> list of FAQ’S in the Knowledge Bank
            </div>
            <div>
              {pricingFaq.map((data, index) => {
                return (
                  <Accordion
                    expanded={expanded === index}
                    onChange={handleChange(index)}
                    className="pricingFaqAccordion"
                  >
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon style={{ color: "white" }} />}
                      aria-controls="panel1bh-content"
                      id="panel1bh-header"
                    >
                      <div
                        className={classes.heading}
                        style={{
                          backgroundColor: "#6D6EF3",
                          borderRadius: "50%",
                          height: "fit-content",
                          textAlign: "center",
                        }}
                      >
                        <div className="faqDropform">?</div>
                      </div>
                      <div className={classes.secondaryHeading}>
                        {data.title}
                      </div>
                    </AccordionSummary>
                    <AccordionDetails>
                      <Typography className={classes.secondaryContent}>
                        {data.content}
                        <ul>
                          {data.table.map((re) => {
                            return <li>{re}</li>;
                          })}
                        </ul>
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default Pricing;
